import { Suspense, lazy } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, Routes, Route, Outlet, Link } from 'react-router-dom';
import * as Sentry from '@sentry/react';
import Home from './app/page';
import { FeedbackFooter } from './components/FeedbackButton';
import ErrorPage from './app/error';
import { PostHogProvider } from './components/PostHogProvider';
import './fonts';
import './app/globals.css';

const FeedbackPage = lazy(() => import('./app/feedback/page'));
const FeedbackInbox = lazy(() => import('./app/admin/feedback/page'));
const Room = lazy(() => import('./app/room/[roomCode]/page'));
const AdminLayout = lazy(() => import('./app/admin/layout'));
const Dashboard = lazy(() => import('./app/admin/page'));
const Cards = lazy(() => import('./app/admin/cards/page'));
const Pending = lazy(() => import('./app/admin/pending/page'));
const Generate = lazy(() => import('./app/admin/generate/page'));
const Evals = lazy(() => import('./app/admin/evals/page'));
const Games = lazy(() => import('./app/admin/games/page'));
const Game = lazy(() => import('./app/admin/games/[code]/page'));

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  enabled: !!import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.MODE,
  sendDefaultPii: false,
  tracesSampleRate: import.meta.env.PROD ? 0.1 : 1,
});

createRoot(document.getElementById('root')!).render(
  <Sentry.ErrorBoundary fallback={({ error, resetError }) => <ErrorPage error={error instanceof Error ? error : new Error(String(error))} reset={resetError} />}>
    <BrowserRouter>
      <PostHogProvider>
        <Suspense fallback={<div className="min-h-screen flex items-center justify-center text-white">Loading…</div>}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/feedback" element={<FeedbackPage />} />
            <Route path="/room/:roomCode" element={<Room />} />
            <Route path="/admin" element={<AdminLayout><Outlet /></AdminLayout>}>
              <Route index element={<Dashboard />} />
              <Route path="cards" element={<Cards />} />
              <Route path="feedback" element={<FeedbackInbox />} />
              <Route path="pending" element={<Pending />} />
              <Route path="generate" element={<Generate />} />
              <Route path="evals" element={<Evals />} />
              <Route path="games" element={<Games />} />
              <Route path="games/:code" element={<Game />} />
            </Route>
            <Route path="*" element={<main className="p-12 text-white">Page not found. <Link to="/">Back to Evoke</Link></main>} />
          </Routes>
        </Suspense>
        <FeedbackFooter />
      </PostHogProvider>
    </BrowserRouter>
  </Sentry.ErrorBoundary>,
);
